<div class="blocked-wrapper blocked-wrapper-media">
  <div class="blocked" role="alert" aria-live="assertive">
    <mm-icon class="blocked__icon" name="lock" aria-hidden="true"></mm-icon>
    <h1 class="blocked__title" id="blocked-title">{{ trans.title | translate }}</h1>
    <p class="blocked__message" id="blocked-message">
      {{ trans.message | translate }}
    </p>
    <button
      mm-button
      class="blocked__action"
      color="primary"
      size="large"
      (click)="redirectToHelp()"
      aria-describedby="blocked-title blocked-message"
    >
      {{ trans.label | translate }}
    </button>
  </div>
</div>
